import request from 'umi-request';

export async function queryValidateConnection(connectionId, data = null) {
  const url = connectionId ? `/connection/validate/${connectionId}` : '/connection/validate';

  return request(url, {
    method: 'POST',
    data: data || {},
  });
}

export async function queryAuthorizeConnection(connectionId, redirectUri) {
  const params = redirectUri ? { redirectUri } : {};
  return request(`/connection/authorize/${connectionId}`, {
    method: 'GET',
    params,
  });
}
